import {
    mina
  } from '@/config/env';
  export const importAll = (context) => {
    const map = new Map();
    for (const key of context.keys()) {
      const keyArr = key.split('/');
      keyArr.shift();
      map.set(keyArr.join('.').replace(/\.js$/g, ''), context(key));
    }
    return map;
  };
  
  export const changeFavicon = (src) => {
    // if (!src) {
    //     src = require('../../static/favicon.ico');
    // }
    const link = document.querySelector('link[rel*=\'icon\']') || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = src;
    const tag = document.querySelector('head');
    tag.appendChild(link);
  };
  
  // formatTime('2020-01', 'yyyy.MM'); --2020.01
  // formatTime('2010.01.02', 'MM月') --01月
  // formatTime('2020-01-02', 'MM月d m分钟'); --01月2 0分钟
  export function formatTime(dateStr, fmt) {
    const date = new Date(dateStr);
    const o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      'S': date.getMilliseconds(), // 毫秒
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
  
    for (const k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
      }
    }
    return fmt;
  }
  
  // 拨打电话
  export function callPhone(phoneNumber) {
    if (phoneNumber) {
      window.location.href = 'tel://' + phoneNumber;
    }
  }
  
  // 访问代理人工作室
  export function viewAgentStudio(agentId) {
    if (agentId) {
      window.location.href = mina + `/h5/myTool/studio?studioId=${this.agentInfo.studioId}&ignoreVisitor=1`;
    }
  }
  
  // 获取时间对应的时间戳 默认为当前时间
  export function getTimeStamp() {
    return Date.parse(new Date());
  }
  
  export function delParam(paramKey, url = window.location.href) {
    let tenantId = sessionStorage.getItem('tenantId');
    if (url.indexOf('?') === -1) {
      url += '?tenantId=' + tenantId
      return url;
    }
    let list = [];
    if (typeof paramKey === 'string') {
      list.push(paramKey);
    } else {
      list = paramKey;
    }
    const pattern = /(\w+)=(\w+)/gi;
    let res = '';
    url.replace(pattern, function (a, key, value) {
      if (!list.includes(key) && key != 1) {
        res += key + '=' + value + '&';
      }
    });
    let newUrl = url.split('?')[0];
  
    if (res.length) {
      newUrl += '?' + res.slice(0, -1);
    }
    newUrl += '&tenantId=' + tenantId
    return newUrl;
  }


// WEBPACK FOOTER //
// ./src/config/customize.js